var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkingLife(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{stroke:#fff;stroke-width:2px;fill:url(#a);}.b{fill:#fff;}.c{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.476,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#149bd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292,
    stopColor: "#2aaada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#65d2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70d9e5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 7)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "matrix(1, 0, 0, 1, -10, -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(10 7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.573 9.666)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M805.228,97.972a4.134,4.134,0,0,1-2.383-.761,4.23,4.23,0,0,1-1.741-4.172l2.218-13.6-9.371-9.6a4.256,4.256,0,0,1-.986-4.343,4.18,4.18,0,0,1,3.337-2.827l12.824-1.959,5.763-12.278a4.16,4.16,0,0,1,7.554,0h0l5.764,12.278,12.824,1.959A4.179,4.179,0,0,1,844.37,65.5a4.258,4.258,0,0,1-.986,4.343l-9.371,9.6,2.218,13.6a4.23,4.23,0,0,1-1.74,4.173,4.114,4.114,0,0,1-4.391.238L818.668,91.13l-11.433,6.32A4.148,4.148,0,0,1,805.228,97.972Zm-4.186-29.751,7.408,7.591a4.285,4.285,0,0,1,1.152,3.671L807.887,90l8.777-4.851a4.118,4.118,0,0,1,4.008,0L829.449,90l-1.716-10.517a4.282,4.282,0,0,1,1.154-3.672l7.406-7.59-10.1-1.542a4.18,4.18,0,0,1-3.153-2.372l-4.376-9.32-4.375,9.322a4.182,4.182,0,0,1-3.153,2.37Zm15.786-17.153,0,.005,0-.006Z",
    transform: "translate(-792.741 -46.014)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingLife);
export default __webpack_public_path__ + "static/media/working-life.13286d6a9658d142483ae1e97420b72b.svg";
export { ForwardRef as ReactComponent };